import script from "./ProjectLidarTo2D.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectLidarTo2D.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__